import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { PlaceholderNote } from "../components/ComingSoon";

const COMMITMENTS = [
  "Designed toward WCAG 2.2 AA, with strong text contrast and large touch targets.",
  "Keyboard-accessible navigation, menus, and forms, with visible focus indicators.",
  "Descriptive link and button labels, and alternative text for meaningful images.",
  "Motion respects your device’s reduced-motion preference.",
  "No autoplaying audio or video, and sticky elements never cover page content.",
  "Support actions are reachable from every page, including by phone (tel:988) and text (sms:988).",
];

export default function Accessibility() {
  return (
    <>
      <PageHero eyebrow="Accessibility" title="Everyone is welcome here" testId="accessibility-hero">
        <p>
          TJ’s Light should be usable by every person who needs it. That is a commitment,
          not a feature.
        </p>
      </PageHero>
      <section aria-labelledby="accessibility-commitments-heading" className="px-4 pb-20 sm:px-8 lg:px-16">
        <div className="mx-auto max-w-3xl">
          <Reveal>
            <h2 id="accessibility-commitments-heading" className="font-serif text-2xl font-normal text-ink sm:text-3xl">
              What this site is built to do
            </h2>
            <ul className="mt-6 list-disc space-y-3 pl-6 text-base leading-relaxed text-body">
              {COMMITMENTS.map((c) => (
                <li key={c}>{c}</li>
              ))}
            </ul>
          </Reveal>
          <Reveal className="mt-10">
            <h2 className="font-serif text-2xl font-normal text-ink sm:text-3xl">Found a barrier?</h2>
            <p className="mt-4 text-base leading-relaxed text-body">
              If anything on this site is difficult to use — with a keyboard, a screen
              reader, magnification, or anything else — please tell us through the
              Contact page. Accessibility problems will be treated as priorities, not
              suggestions.
            </p>
          </Reveal>
          <Reveal className="mt-10">
            <PlaceholderNote testId="accessibility-contact-placeholder">
              <strong className="font-semibold text-ink">Accessibility contact — coming soon.</strong>{" "}
              A dedicated accessibility contact method will be listed here once the
              foundation’s email address is confirmed.
            </PlaceholderNote>
          </Reveal>
        </div>
      </section>
    </>
  );
}
